import { LayoutFontStyle } from '../../types/types';

export type KonvaFontStyle = {
  // Konva Text fontStyle: 'normal' | 'bold' | 'italic' | 'italic bold'
  fontStyle: string;
  // Konva Text textDecoration: '' | 'underline' | 'line-through' | 'underline line-through'
  textDecoration: string;
};

// Maps the flat fontStyle array to Konva Text style props.
export const fontStyleToKonva = (
  fontStyle: LayoutFontStyle[] = []
): KonvaFontStyle => {
  const weight = [
    fontStyle.includes('bold') ? 'bold' : '',
    fontStyle.includes('italic') ? 'italic' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const decoration = [
    fontStyle.includes('underline') ? 'underline' : '',
    fontStyle.includes('strikethrough') ? 'line-through' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return {
    fontStyle: weight || 'normal',
    textDecoration: decoration,
  };
};
